const ToggleSwitch = ({ onToggle, active }) => {
  return (
    <div
      className="border border-solid border-ink rounded-ns-tile p-0.5 w-[62px] cursor-pointer"
      onClick={onToggle}
    >
      <div
        className={`rounded-full transition-all duration-200 transform ${
          active
            ? "bg-ink translate-x-[100%]"
            : "bg-ink transform translate-x-0"
        } h-6 w-7`}
      />
    </div>
  );
};

export default ToggleSwitch;
